import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signIn } from '../../store/actions/authActions';
import { Redirect } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';


class SignIn extends Component {
    constructor(props) {
        super();
    }

    state = {
        email: '',
        password: ''
    }
    
    handleChange = (e) => {
        const { target } = e;

        this.setState( state => ({ 
            ...state,
            [target.id]: target.value
        }));
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.signIn(this.state);
    }

    render() {
        const { authError, auth } = this.props;
        
        if(auth.uid) return <Redirect to={ROUTES.HOME} />

        const pageCode = auth.isLoaded ? (         
            <div className="container">
                <div className="credentials-form sign-forms" >
                    <form onSubmit={this.handleSubmit} className="form-group">
                        <h1 className="">Login</h1>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                name="password"
                                id="password"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-primary btn-block btn-custom">Login</button>
                            {authError ? <div className="w-100"><br /><p className="text-center text-danger">{authError}</p></div> :  null }
                        </div>
                    </form> 
                </div>
            </div>) : null;

        return (
            pageCode
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authError: state.auth.authError,
        auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (creds) => dispatch(signIn(creds))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);